import request from './request'

export function fetchJobs(params = {}) {
  return request.get('/jobs', { params })
}

/** 按确认后的任务清单创建 Job {product, kit_type, tasks}
 *  注意：必须带 /create，否则 JFinal 会把 POST /jobs 命中到 index()（列表查询） */
export function createJob(payload) {
  return request.post('/jobs/create', payload)
}

export function fetchJobDetail(id) {
  return request.get('/jobs/detail', { params: { id } })
}

export function cancelJob(id) {
  return request.post('/jobs/cancel', null, { params: { id } })
}

/** 对某张素材二次修改重新生成（material_id + 修改意见 feedback），走正常扣费 */
export function createRedo(payload) {
  return request.post('/jobs/redo', payload)
}
